// The whole code is copied from VPC.

/* eslint-disable @typescript-eslint/no-explicit-any */
// NOTE: The following code originated in the Phoenix codebase, but has been modified for use in VPC.
/**
 *  Status of a LoadableModel at any point of time.
 */
export enum LoadingStatus {
  /**
   * Initial/default state.
   * In this state, the loadable is empty.
   * From this state, the loadable can transition only to the LOADING state.
   */
  NOT_LOADED = 'NOT_LOADED',

  /**
   * The loadable is being loaded (e.g., from local cache or from remote server).
   * In this state, the loadable may or may not be empty (it might already have some data, while loading new data).
   * From this state, the loadable can transition to either LOADED state or FAILED state.
   */
  LOADING = 'LOADING',

  /**
   * The loadable has been loaded successfully.
   * In this state, the loadable may be empty (e.g., server did not provide any data).
   * From this state, the loadable can transition only to the REFRESHING state.
   */
  LOADED = 'LOADED',

  /**
   * The loadable has failed to load.
   * In this state, the loadable may or may not be empty (e.g., some data was fetched from the previous LOADING state).
   * From this state, the loadable can transition only to the LOADING state.
   */
  FAILED = 'FAILED',
}

export interface Loadable<T> {
  readonly loadingStatus: LoadingStatus;
  readonly errorMessage?: string;
  readonly content?: T;
}

// tslint:disable-next-line:no-any
const loadingLoadable: Loadable<any> = {
  loadingStatus: LoadingStatus.LOADING,
  errorMessage: '',
  content: undefined,
};

// tslint:disable-next-line:no-any
const notLoadedLoadable: Loadable<any> = {
  loadingStatus: LoadingStatus.NOT_LOADED,
  errorMessage: '',
  content: undefined,
};

export const Loadable = {
  failed<T>(errorMessage: string, content?: T): Loadable<T> {
    return {
      loadingStatus: LoadingStatus.FAILED,
      errorMessage,
      content,
    };
  },
  loaded<T>(content: T): Loadable<T> {
    return {
      loadingStatus: LoadingStatus.LOADED,
      errorMessage: '',
      content,
    };
  },
  loading<T>(content?: T): Loadable<T> {
    return {
      ...loadingLoadable,
      content,
    };
  },
  notLoaded: notLoadedLoadable,
};
